import { orderBy } from '../../../../util/lodashlike';

export const EXCLUDED_RED_FLAGS = ['OTHERS', 'Historical Alert Risk'];

export const getNTopOrderedFeatures = (data, numberOfFeatures) => {
  const orderedData = orderBy(data, ['contribution'], ['desc']);
  return Array.isArray(orderedData)
    ? orderedData.slice(0, numberOfFeatures)
    : [];
};

export const MAX_NUM_FEATURES = 10;

/**
 * FEATURE_VIEW header
 * @type {({name: string, key: string}|{name: string, key: string}|{name: string, key: string})[]}
 */
export const FEATURE_VIEW_MAP = [
  {
    name: 'Red Flag',
    key: 'name'
  },
  {
    name: 'Contribution',
    key: 'contribution'
  },
  {
    name: 'features',
    key: 'features'
  }
];
